import axios from '../../utils/http'
import {post, get, put, axiosDelete} from '../../utils/http'

//带cookie
//axios.defaults.withCredentials = true;
axios.defaults.headers = {
    'Content-Type': 'application/json; charset=utf-8',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Credentials': true,
    'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
    'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token'
}




export function getO365Url(data) {
    return get(`/api/services/app/O365Service/GetDoLoginAuthUri?langname=${data}`);
}

export function doO365Login(data) {
    return post(`/api/TokenAuth/ExternalAuthenticate`,data,{timeout:1000*20});
}


// export function query(name) {
//     var reg = new RegExp("(^|&)" + unescape(name) + "=([^&]*)(&|$)", "i");
//     var r = window.location.href.substr(1).match(reg);
//     if (r != null) return decodeURIComponent(r[2]);
//     return null
// }